// @flow
import React, { useState, useEffect } from 'react';

import styles from './userContactsForm.css';
import Row from './row';
import ContactsTypeahead from '../ContactsTypeahead';

type InputDefinitionType = {
  accessName: string,
  canEdit: boolean,
  hideOnEdit: boolean,
  componentType: string,
  highlight: Boolean,
  /* validation: (value: any) => boolean, */
};

type UserContactsFormProps = {
  onChange: Function,
  onAdd: Function,
  onRemove: Function,
  onEdit: Function,
  values: Array<any>,
  canManuallyAdd: boolean,
  canEditValues: boolean,
  inputsDefinition: Array<InputDefinitionType>,
  validation: (row: any) => boolean,
};

const UserContactsForm = ({
  onChange,
  value,
  canManuallyAdd,
  onAdd,
  onRemove,
  onEdit,
  inputsDefinition,
  validation,
}: UserContactsFormProps) => {
  /* useEffect(() => {
    if (onChange) onChange(data);
  }, [data]); */

  const onRemoveData = (id) => {
    if (onRemove) onRemove(id);
  };

  const changeData = (newData: any) => {
    const validationResults = validation ? validation(newData, value) : [true, {}];
    if (validationResults.canSave) {
      if (onEdit) onEdit(newData);
    }

    return validationResults;
  };

  const onAddData = (newData: any) => {
    const validationResults = validation ? validation(newData, value) : [true, {}];
    if (validationResults.canSave || newData.fromApi) {
      if (onAdd) onAdd(newData);
    }
    return validationResults;
  };

  return (
    <div className={styles.container}>
      {value.map((item, index) => (
        <Row
          value={item}
          inputsDefinition={inputsDefinition}
          remove={() => onRemoveData(item.profile_id)}
          onChange={changeData}
        />
      ))}
      {canManuallyAdd && (
        <Row
          isManually
          onAdd={onAddData}
          inputsDefinition={inputsDefinition}
        />
      )}
      <div className={styles.typeaheadArea}>
        <p className={styles.searchContacts}>O busca uno existente:</p>
        <div className={styles.typeahead}>
          <ContactsTypeahead
            onSelect={(selected) => {
              let repeated = false;
              value.forEach((contact) => {
                if (contact.id === selected.user_id) repeated = true;
              });

              if (!repeated) onAddData({ fromApi: true, profile_id: selected.id, ...selected });
            }}
            userType="parent"
          />
        </div>
      </div>
    </div>
  );
};

export default UserContactsForm;



// WEBPACK FOOTER //
// ./src/scripts/components/UserContactsForm/index.jsx